import { gql } from '@apollo/client';
import { InvoicePaymentType } from '@src/types/enums';

export const CREATE_PAYMENT_INSTRUCTION = gql`
  mutation CreatePaymentInstruction(
    $businessId: ID!
    $paymentInstructionInvoices: [PaymentInstructionInvoicesInput!]!
  ) {
    createPaymentInstruction(
      businessId: $businessId
      paymentInstructionInvoices: $paymentInstructionInvoices
    ) {
      success
    }
  }
`;

export type CreatePaymentInstructionsMutationReturn = {
  success: boolean;
};

export type CreatePaymentInstructionsMutationVariables = {
  businessId: string;
  paymentInstructionInvoices: Array<{
    invoiceId: string;
    providerEmails: string[];
    amountCents?: number;
    paymentMethod?:
      | InvoicePaymentType.STP_PAYMENT
      | InvoicePaymentType.HIGO_PAYMENT
      | InvoicePaymentType.REQUEST_BANKING_INFO;
    clabe?: string;
    paymentConcept?: string;
  }>;
};
